import React, {Component} from "react"
import scrollIntoView from "scroll-into-view-if-needed"
import PropTypes from "prop-types"
import {isEqual} from "lodash"
import {QuestionsQuery} from "@irati/insights/apollo/query/question"
import {AnalysisContext, QuestionStatsContext} from "@irati/insights/context"
import getId from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import Expand from "@irati/ui/src/Expander"
import Loader from "@irati/ui/src/Loading/Loader"
import ReportingQuery from "@irati/insights/apollo/query/reporting/get"
import {doIHavePermission} from "@irati/utils/permissions/HasPermissionTo"
import auth from "@irati/auth"
import {overrideAuth} from "@irati/insights/utils/apollo"
import withContext from "@irati/insights/context/utils/withContext"

import QuestionsList from "./QuestionsList"
import {SectionTitle} from "../index"
import tracking from "../../../tracking/shared"


class Questions extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    analysisContext: PropTypes.object
  }

  static defaultProps = {
    analysisContext: {}
  }

  constructor(props) {
    super(props)
    this.idNamespace = getId("QuestionsController", props)
    this.state = {isOpen: false}
  }

  handleToggle = (isExpanded) => {
    this.setState((prevState) => ({isOpen: !prevState.isOpen}))
    if (!isExpanded) {
      const node = document.getElementById(this.idNamespace)
      scrollIntoView(node, {block: "start"})
    } else {
      tracking.viewQuestionsResponses()
    }
  }

  close = () => {
    this.setState({isOpen: false})
  }

  componentDidUpdate({analysisContext: {filters: prevFilters}}) {
    const {analysisContext: {filters}} = this.props
    if (!isEqual(filters, prevFilters)) this.close()
  }

  render() {
    const {formatMessage, analysisContext} = this.props
    const {schedule, filters, tenantId: tenant, isDemo, demoTenantAccessToken} = analysisContext
    const {isOpen} = this.state
    const showMoreCopy = formatMessage({id: "insights.analysis.questions.expander.showAll"})
    const showLessCopy = formatMessage({id: "insights.analysis.questions.expander.showLess"})
    const showCOT = doIHavePermission(["insights.changeOverTime"], auth.apps())
    const {context} = overrideAuth(demoTenantAccessToken, isDemo)

    const {id: scheduleId, drivers: {results: drivers}} = schedule
    const {teamId: team, driverId, time: minOpenedAt} = filters

    const driver = driverId || drivers[0].id || ""
    const driverUuid = (!isOpen || driverId) ? driver : ""
    const variables = {tenant, scheduleId, team, minOpenedAt}

    const showExpander = drivers.length > 1 && !driverId

    return (
      <div id={this.idNamespace}>
        <ReportingQuery variables={{params: {...variables, driverId}}} useLoader={false}>
          {({stats: {timesAnswered: responseAmount}, loading}) => {
            return (
              <SectionTitle
                id={this.idNamespace}
                title={formatMessage({id: "insights.analysis.questions.header.questionStats"})}
                badgeCopy={
                  !loading && responseAmount
                    ? formatMessage({id: "insights.analysis.questions.summaryLabel"}, {responseAmount})
                    : ""
                } />
            )
          }}
        </ReportingQuery>
        <QuestionsQuery
          useLoader={false}
          withHistoricalData={showCOT}
          schedule={schedule}
          filters={filters}
          tenant={tenant}
          context={context}
          variables={{
            driverUuid,
            withQuestionDriver: true
          }}>
          {({questions: {results = []}, loading, historicalLoading}) => {
            if (loading && results.length === 0) return <Loader />
            return (
              <QuestionStatsContext.Provider value={{
                loading,
                historicalLoading
              }}>
                <QuestionsList
                  id={this.idNamespace}
                  questions={results}
                  loading={loading}
                  drivers={drivers} />
              </QuestionStatsContext.Provider>
            )
          }}
        </QuestionsQuery>
        {showExpander && <Expand showText={showMoreCopy} hideText={showLessCopy} above onChange={this.handleToggle} />}
      </div>
    )
  }
}

export default injectIntl(withContext({analysisContext: AnalysisContext})(Questions))
